module.exports = __webpack_public_path__ + "img/5.2bfb3c4f.jpeg";